import { render, staticRenderFns } from "./Line2.vue?vue&type=template&id=5c95e36c&scoped=true&"
import script from "./Line2.vue?vue&type=script&lang=js&"
export * from "./Line2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c95e36c",
  null
  
)

export default component.exports